import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Auth0Service } from 'src/app/shared/services/auth0.service';

@Injectable()
export class AccountSecureLinkGuardService {
  constructor(private router: Router, private auth0Service: Auth0Service) {}

  private isValidSecureLink(secureLinkId: string, target: string): Observable<boolean> {
    var obs = this.auth0Service.isValidSecureLink(secureLinkId);

    obs.subscribe((isValid) => {
      if (!isValid) {
        this.router.navigate([target]);
      }
    });

    return obs;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    let target = route.data.target ? route.data.target : '/home';
    return this.isValidSecureLink(route.params.secureLinkId, target);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
